type HttpMethodLiterals = "GET" | "POST" | "PUT";

type ErrorResponseBody = {
  code: string;
  msg: string;
};

export const TypedResource = <T, B>(
  path: string,
  method: HttpMethodLiterals,
  body?: B,
): Promise<T> => {
  return handleType<T>(
    fetch(buildURL(path), {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }),
  );
};

const handleType = <T>(task: Promise<Response>): Promise<T> => {
  return new Promise((resolve, reject) => {
    task
      .then((res) => {
        if (res.ok) {
          res
            .json()
            .then((json) => resolve(json))
            .catch((e) => reject(e));
        } else {
          reject(res);
        }
      })
      .catch((e) => reject(e));
  });
};

export const BlobResource = (
  path: string,
  method: HttpMethodLiterals,
): Promise<Blob> => {
  return handleBlob(
    fetch(buildURL(path), {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }),
  );
};

const handleBlob = (task: Promise<Response>): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    task
      .then((res) => {
        if (res.ok) {
          res
            .blob()
            .then((blob) => resolve(blob))
            .catch((e) => reject(e));
        } else {
          reject(res);
        }
      })
      .catch((e) => reject(e));
  });
};

const buildURL = (path: string): string => {
  const url = new URL(
    `${window.location.protocol}//${window.location.host}${path}`,
  );
  if (
    typeof URLSearchParams === "function" &&
    url.searchParams instanceof URLSearchParams
  ) {
    // add timestamp not to cache API response
    url.searchParams.append("_", Date.now().toString());
  }
  return url.toString();
};

export const HandleErrorType = (
  errRes: Response,
): Promise<ErrorResponseBody> => {
  return new Promise((resolve, reject) => {
    errRes
      .json()
      .then((e) => resolve(e))
      .catch((e) => reject(e));
  });
};
